// LAP-550 — Card Objectifs : 3 barres de progression annotées
import React from 'react'
import { Box, Typography, LinearProgress } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined'
import CardHeader from '../../_shared/CardHeader'
import { invTheme } from '../../_shared/theme'
import { formatMoney, formatNumber } from '../../_shared/gridCols'

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 999,
  backgroundColor: 'rgba(255,255,255,0.08)',
  '& .MuiLinearProgress-bar': {
    borderRadius: 999,
    background: 'linear-gradient(90deg, #34d399, #63a0ff)',
  },
}))

function TargetRow({ label, objective, currentLabel, value, unit }) {
  const pct = Math.max(0, Math.min(value || 0, 100))
  return (
    <Box sx={{ width: '100%', position: 'relative', mt: 3 }}>
      <Box display="flex" mb={1} alignItems="baseline">
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>
          {label}
        </Typography>
        <Typography
          sx={{ ml: 'auto', color: '#cfe1ff', fontWeight: 600, fontSize: 13 }}
        >
          {objective} {unit}
        </Typography>
      </Box>
      <BorderLinearProgress variant="determinate" value={pct} />
      <Box
        sx={{
          position: 'absolute',
          top: 30,
          left: `${Math.max(5, Math.min(pct, 95))}%`,
          transform: 'translateX(-50%)',
          mt: 0.5,
        }}
      >
        <Box
          sx={{
            fontSize: 11,
            color: invTheme.positive,
            backgroundColor: invTheme.positiveSoft,
            px: 0.75,
            py: 0.25,
            borderRadius: 999,
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}
        >
          {currentLabel}
        </Box>
      </Box>
    </Box>
  )
}

export default function UserTarget({ report }) {
  const { t } = useTranslation('layout')
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon={<FlagOutlinedIcon fontSize="small" />}
        title={t('investments.portfolio.invValue.title')}
        subtitle={t('investments.portfolio.invValue.yearlyChange')}
        value={report?.total !== undefined ? formatMoney(report?.total) : null}
        delta={report?.change !== undefined ? { value: report?.change, unit: '%' } : null}
      />
      <Box mt={2} height="100%" px={1}>
        {/* Toutes les valeurs passent par formatMoney / formatNumber : jamais de
            traîne décimale type « 1.6666666666666667 % ». */}
        <TargetRow
          label={t('investments.portfolio.target.passiveIncome')}
          objective={formatNumber(report?.income?.objective)}
          currentLabel={formatMoney(report?.income?.current)}
          value={report?.income?.change}
          unit="€"
        />
        <TargetRow
          label={t('investments.portfolio.target.investmentReturn')}
          objective={formatNumber(report?.return?.objective)}
          currentLabel={`${formatNumber(report?.return?.change)} %`}
          value={report?.return?.change}
          unit="%"
        />
        <TargetRow
          label={t('investments.portfolio.target.annualGrowth')}
          objective={formatNumber(report?.growth?.objective)}
          currentLabel={`${formatNumber(report?.growth?.change)} %`}
          value={report?.growth?.change}
          unit="%"
        />
      </Box>
    </Box>
  )
}
